import React from "react";
import { Grid } from "@material-ui/core";
import moment from "moment";

import DocIconGrey from "../../docIconGrey.svg";
import { Row } from "../styles";

import {
  IconWrapper,
  LeftContentWrapper,
  LevelWrapper,
  NameTypeWrapper,
  NameWrapper,
  RightContentWrapper,
  StyledChevronRight,
  Wrapper,
  StyledDate
} from "./sourceFileListItemStyles";

const SourceFileListItem = props => {
  const { onClick, sourceFileId, sourceName, summary, typeName, latestAsOfDate, latestCreatedAtDate } = props;

  return (
    <Row>
      <Grid container>
        <Wrapper>
          <LeftContentWrapper>
            <IconWrapper>
              <img src={DocIconGrey} alt="Doc Icon" height={36} width={36} />
            </IconWrapper>
            <NameTypeWrapper>
              <NameWrapper>{`${sourceName} ${typeName}`}</NameWrapper>
              <StyledDate>{`Data As Of ${latestAsOfDate ? moment.utc(latestAsOfDate).format("MMMM D, Y") : "Date is Not Available"}`}</StyledDate>
              <StyledDate size="12px" color="#5F6368">
                {`Last Updated ${latestCreatedAtDate ? moment.utc(latestCreatedAtDate).format("MMMM D, Y") : "Date is Not Available"}`}
              </StyledDate>
            </NameTypeWrapper>
          </LeftContentWrapper>
          <RightContentWrapper onClick={() => onClick(sourceFileId)}>
            <LevelWrapper>{summary}</LevelWrapper>
            <StyledChevronRight />
          </RightContentWrapper>
        </Wrapper>
      </Grid>
    </Row>
  );
};

export default SourceFileListItem;
